import template from './simpleFieldInstance.html';
import controller from './simpleFieldInstance.controller';

let simpleFieldInstanceComponent = {
  restrict: 'E',
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    field: '<',
  }
};

export default simpleFieldInstanceComponent;
